module.exports = __webpack_public_path__ + "c5a8f042ecc397748e8cf07e8f0100d8.pdf";